import { useEffect } from "react";
import { initQZTray } from "../../Utils/qzSetup";
import qz from "qz-tray";


const LabelPrinter = () => {

    useEffect(() => {
        const setupPrinter = async () => {
            const printers = await initQZTray();
            const tscPrinter = printers?.find((p) =>
                p?.includes("TSC TTP-244 Pro")
            );

            if (tscPrinter) {
                // Example: Print a test label
                await printLabel(tscPrinter, {
                    barcode: "1234567890",
                    name: "Test Product",
                    sale_price: 300
                });
            }
        };

        setupPrinter();
    }, []);

    return;
};

// Example TSPL print function
const printLabel = async (printer, item) => {
    const tspl = `
SIZE 50 mm,20 mm
GAP 2 mm,0
DENSITY 8
SPEED 4
DIRECTION 1
CLS
BARCODE 10,10,"128",30,1,0,2,2,"${item.barcode}"
TEXT 10,45,"3",0,1,1,"${item.name}"
TEXT 10,65,"3",0,1,1,"EGP ${item.sale_price}"
PRINT 1
`;

    try {
        await qz.print({
            printer,
            type: 'raw',
            format: 'command',
            data: tspl
        });
        console.log("✅ Label printed:", item.name);
    } catch (err) {
        console.error("❌ Print error:", err);
    }
};

export default LabelPrinter;
